import { endOfDay, startOfDay } from "date-fns";

import { AlignmentFilters } from "./components/Filters";

import { addTimezoneOffset } from "../../../../../utils/dateUtils";

export const getGoalAlignmentSearchServiceFilters = (
	filters: Partial<AlignmentFilters>,
	searchValue?: string,
	isTopLevel?: boolean,
	rootGoalId?: string
) => {
	const finalFilters = {};

	if (rootGoalId) {
		finalFilters["ancestors_in"] = [rootGoalId];
		finalFilters["direct_ancestor_eq"] = rootGoalId;
		finalFilters["descendants.status_in"] = ["active", "completed"];
	}

	if (isTopLevel) {
		finalFilters["is_top_eq"] = true;
	}

	if (filters.assignee && filters.assignee.length > 0) {
		finalFilters["assignee_or_descendants_assignee_in"] = filters.assignee.map((assignee) => assignee.id);
	}

	if (filters.dueDateAfter) {
		const date = addTimezoneOffset(filters.dueDateAfter);
		finalFilters["end_date_or_descendants_end_date_gt"] = endOfDay(date).toISOString();
	}

	if (filters.dueDateBefore) {
		const date = addTimezoneOffset(filters.dueDateBefore);
		finalFilters["end_date_or_descendants_end_date_lt"] = startOfDay(date).toISOString();
	}

	if (filters.category && filters.category.length > 0) {
		finalFilters["categories_or_descendants_categories_in"] = filters.category.map((category) => category.id);
	}

	if (filters.status && filters.status.length > 0) {
		finalFilters["status_or_descendants_status_in"] = filters.status;
	}

	if (filters.outlook && filters.outlook.length > 0) {
		finalFilters["color_or_descendants_color_in"] = filters.outlook.map((outlook) => outlook.id);
		// if outlook contains value "none" then wen need to set the include not selected outlooks
		if (filters.outlook.some((outlook) => outlook.id === "none")) {
			const outlooks = filters.outlook.filter((outlook) => outlook.id !== "none");
			if (outlooks.length > 0) {
				finalFilters["color_or_descendants_color_in"] = outlooks.map((outlook) => outlook.id);
			}
			finalFilters["color_include_not_selected_eq"] = true;
		} else {
			finalFilters["color_or_descendants_color_in"] = filters.outlook.map((outlook) => outlook.id);
		}
	}

	if (searchValue) {
		finalFilters["name_or_descendants_name_re"] = searchValue;
	}

	return finalFilters;
};
